import { locales, INTL_MARKETS } from '@americanexpress/conditional-features';

const {
  EN_GB,
  EN_AU,
  EN_CA,
  FR_CA,
  EN_HK,
  EN_NZ,
  EN_IN,
  SV_SE,
  NL_NL,
  EN_SG,
  EN_US,
  DE_DE,
  ES_MX,
  IT_IT,
  ES_ES,
  JA_JP,
  ZH_HK,
} = locales;

export const hasCenturionImageInHeader = [EN_GB];
export const hasCenturionRule = {
  devFlag: 'intlHomepageCenturionRollout',
  devLocales: [],
  prodLocales: [EN_US, EN_GB],
};
export const hasHomePageCardOffersRule = [...INTL_MARKETS];
export const hasLegalRule = [
  EN_GB, EN_AU, EN_CA, FR_CA, EN_HK, EN_NZ, EN_IN, SV_SE, NL_NL, EN_SG, ZH_HK,
];
export const hasFooterLinksRule = [EN_CA, FR_CA];
export const hasMyTravelBenefitsRule = [
  EN_GB,
  EN_AU,
  EN_CA,
  FR_CA,
  EN_NZ,
  EN_US,
  DE_DE,
  ES_MX,
  IT_IT,
  JA_JP,
  ES_ES,
];
export const hasTravelCreditCenturionCardArtRule = [ES_MX, JA_JP, IT_IT, EN_CA, FR_CA];
export const hasTravelCreditOverlayRule = [EN_US];
export const hasTravelCreditTabRule = {
  devFlag: 'intlTravelCreditTab',
  devLocales: [],
  prodLocales: [DE_DE, EN_AU, EN_CA, EN_GB, EN_NZ, ES_ES, ES_MX, FR_CA, IT_IT, JA_JP],
};
export const hasVacationPackagesPathRule = [EN_US];
export const hasDisableCardSpecificBenefitsRule = [ES_ES];
export const hasVacationRentalsRule = [EN_US];

export const hasDisplayEarlyTenureMarketingTileRule = {
  devFlag: 'earlyTenureMarketingTile',
  devLocales: [EN_US],
  prodLocales: [],
};

export const hasAbandonHotelRule = {
  devFlag: 'abandonHotel',
  devLocales: [EN_US],
  prodLocales: [],
};

export const hasDisablePackagesRule = [EN_US, JA_JP, DE_DE, EN_IN];

export const hasProjectAdsRule = [EN_US];
